import React from "react"
import { message, Typography } from "antd"
import { RegisterFormWrapper } from "./RegisterFormWrapper"
import { SubscribeForm } from "../SubscribeForm/SubscribeForm"

message.config({
  top: 100
})

export const RegisterPreliminaryForm = () => {
  return (
    <RegisterFormWrapper>
      <Typography.Title level={2}>Registrační formulář</Typography.Title>

      <SubscribeForm tags={["Ajťácká detektivka"]} description={""} />
    </RegisterFormWrapper>
  )
}
